import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/jackpotcapital/default.vue").then(m => m.default || m))
}